import { fetchAttachments } from '@features/attachments/query-api'
import { QueryProps } from '@features/attachments/types/queryProps'

export const getReceiptsQueryFunction = ({
  eInvoiceFilter,
  organizationId,
  page,
  pageSize,
  searchQuery,
  sortDirection,
  sortProperty,
  fillType,
  include,
  type,
}: QueryProps) =>
  fetchAttachments({
    eInvoiceFilter,
    organizationId,
    page,
    pageSize,
    searchQuery,
    sortDirection,
    sortProperty,
    fillType,
    include,
    type,
  })
